import Typography from '../Typography';
import CircularProgress from '../CircularProgress';
import { useEffect, useState } from '@wordpress/element';
import ItemSelect from '../ItemSelect';
import { InputBase } from '../Input/InputBase';

export default function Select({
  desabilitado,
  className,
  icon,
  component,
  classNameInput,
  valorInput,
  setValorInput,
  placeholder,
  label,
  opcoes,
  carregando,
  renderValue,
  checkbox = false,
}) {
  const [ativo, setAtivo] = useState(false);

  return (
    <div
      className={`w-full grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex ${className}`}
    >
      {label && <Typography component="body1-semibold">{label}</Typography>}

      <div className="relative w-full">
        <InputBase
          readOnly
          component={component}
          classNameInput={classNameInput}
          disabled={desabilitado}
          value={
            renderValue && checkbox ? renderValue : opcoes?.find(a => a.valor == valorInput)?.titulo
          }
          onClick={() => setAtivo(!ativo)}
          icon={
            carregando ? (
              <div className="absolute top-2/4 right-3 grid h-5 w-5 -translate-y-2/4 place-items-center">
                <CircularProgress />
              </div>
            ) : (
              icon
            )
          }
        />

        <div
          id="checkBoxes"
          className={`${
            ativo ? '' : 'hidden'
          } mt-2 w-full z-50 absolute bg-neutras-white px-2 py-1 flex flex-col border border-solid border-text-tertiary rounded divide-y divide-fundo-borda`}
        >
          {opcoes.map((i, index) => (
            <ItemSelect
              onClick={() => {
                setAtivo(false);
                if (i?.onClickOpcao) {
                  i?.onClickOpcao(i?.valor);
                }
              }}
              key={i.valor}
              texto={i.titulo}
              index={index}
              item={i}
              setValorInput={setValorInput}
              valorInput={valorInput}
              checkbox={checkbox}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
